export default __webpack_public_path__ + "static/media/login-screen-1.849674b0.png";